import Track from './Track';
import ServiceGTag from './ServiceGTag';
import ServiceMixpanel from './ServiceMixpanel';

interface IService {
  enabled: boolean,
  config: Record<string, string>
}

class Analytics {
  private cardId: number = 0;

  private readonly serviceGTag: ServiceGTag | null = null;

  private readonly serviceMixpanel: ServiceMixpanel | null = null;

  constructor() {
    if (typeof window === 'undefined') {
      this.serviceGTag = null;
      this.serviceMixpanel = null;
      return;
    }

    let services: Record<string, IService> = {};
    if (process.env.REACT_APP_ANALYTIC_SERVICES) {
      try {
        services = JSON.parse(process.env.REACT_APP_ANALYTIC_SERVICES);
        // eslint-disable-next-line no-empty
      } catch {
      }
    }

    if ('gtag' in services && services.gtag?.enabled === true) {
      this.serviceGTag = new ServiceGTag(services.gtag.config);
    }

    if ('mixpanel' in services && services.mixpanel?.enabled === true) {
      this.serviceMixpanel = new ServiceMixpanel(services.mixpanel.config);
    }
  }

  public setCardId = (id: number): void => {
    this.cardId = id;
  };

  public track = (): Track => {
    return new Track(this.send);
  };

  private send = (event: string, label: string, payload: Record<string, any> = {}, callback?: CallableFunction): void => {
    if (process.env.REACT_APP_ANALYTIC_LOG === 'true') {
      console.log('Analytics::track', event);
    }
    Promise.all([
      this.serviceGTag ? this.serviceGTag.send(event, label, payload) : null,
      this.serviceMixpanel ? this.serviceMixpanel.send(event, label, { ...payload, id: this.cardId }) : null,
    ]).then(() => {
      if (typeof callback === 'function') {
        callback();
      }
    }).catch((error) => {
      throw error;
    });
  };
}

export default new Analytics();
